/* src/app/components/subscription/subscription.component.scss */
.setting-section .sub-block-head {
  text-align: center;
  margin-bottom: 0.5rem;
}
.setting-section .plan-wrapper {
  max-width: 960px;
  margin: auto;
  display: flex;
  gap: 15px;
}
.setting-section .list-group {
  width: 600px;
}
.setting-section .list-group .list-group-item {
  background: #fcfafa;
  font-size: 0.9rem !important;
}
.setting-section a.upgrade-btn {
  color: hsl(217, 71%, 53%) !important;
  font-weight: bold;
}
.setting-section .card.box-overflow {
  height: calc(100vh - 100px);
}
.setting-section .card-body {
  padding: 1rem !important;
}
.setting-section ::ng-deep .field.StripeElement {
  border-color: hsl(0, 0%, 80%) !important;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  height: 2.5em !important;
  padding-top: 8px;
}
.setting-section ::ng-deep .field.StripeElement .ElementsApp input {
  height: 2.5em !important;
}
.setting-section .settingsCard-header .main-heading {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  width: 100%;
}
.setting-section .settingsCard-header .main-heading .second {
  width: auto;
}
table th,
table td {
  max-width: 300px;
  padding: 8px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table tbody tr:hover td {
  background: var(--table-hover-bg) !important;
}
table thead {
  position: sticky;
  inset-block-start: 0;
}
table thead th {
  padding: 10px 3px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f4f4f4;
  color: #111;
}
@media screen and (max-width: 767px) {
  .plan-wrapper {
    display: block !important;
  }
  .tabs {
    display: block !important;
  }
}
/*# sourceMappingURL=subscription.component.css.map */
